import Signal from '@/makio/core/Signal'

const TIME_STEP = 8
const MAX_DT = 100
const MAX_STEPS = 10

const getDevicePixelRatio = () => {
	const ratio = Math.max( 1, Number( window.devicePixelRatio ) || 1 )
	const compact = Math.min( window.innerWidth, window.innerHeight ) < 720 || window.matchMedia( '(pointer: coarse)' ).matches
	return Math.min( ratio, compact ? 1.5 : 2 )
}

class Stage {
	pause = false
	lastTime = performance.now()
	dtOffset = 0
	width = window.innerWidth
	height = window.innerHeight
	devicePixelRatio = getDevicePixelRatio()
	onResize = new Signal()
	onUpdate = new Signal()
	onRender = new Signal()

	constructor() {
		window.addEventListener( 'resize', this.resize )
		window.addEventListener( 'orientationchange', this.resize )
		this.resize()
		requestAnimationFrame( this.update )
	}

	resize = () => {
		this.width = window.innerWidth
		this.height = window.innerHeight
		this.devicePixelRatio = getDevicePixelRatio()
		this.documentHeight = document.documentElement.clientHeight
		this.onResize.dispatch()
	}

	update = () => {
		if ( this.pause )
			return requestAnimationFrame( this.update )

		const now = performance.now()
		let dt = Math.min( now - this.lastTime, MAX_DT )
		this.lastTime = now
		this.dtOffset += dt

		// let steps = 0
		// while ( this.dtOffset >= TIME_STEP && steps < MAX_STEPS ) {
		// 	this.onUpdate.dispatch( TIME_STEP )
		// 	this.dtOffset -= TIME_STEP
		// 	steps++
		// }
		// this.onRender.dispatch( this.dtOffset / TIME_STEP )

		this.onUpdate.dispatch( dt )
		this.onRender.dispatch( dt )
		requestAnimationFrame( this.update )
	}
}

const stage = new Stage()
export default stage
export { stage, Stage }
